/**
 * Для создания шины событий
 */
export class Emitter {
  constructor() {
    this._eventHandlers = new Map();
  }

  /**
   * Вызвать событие с данными
   * @param {string|symbol} eventName 
   * @param {any} payload 
   */
  emit(eventName, payload) {
    console.log('emit', eventName, payload);
    
    let deleteHandlerIndexes = [];
    const handlers = this._eventHandlers.get(eventName);
    if (!handlers) return;

    handlers.forEach((h) => {
      if (typeof h.fn === 'function') h.fn(payload);
      if (h.once) deleteHandlerIndexes.push(h);
    });
    deleteHandlerIndexes.forEach((h) => handlers.delete(h));
  }

  /**
   * Подписка на событие
   * @param {string|symbol} eventName 
   * @param {() => void} handler 
   * @param {boolean} [once=false] 
   */
  on(eventName, handler, once = false) {
    console.log('on', eventName);
    
    let handlers = this._eventHandlers.get(eventName);
    if (!handlers) {
      handlers = new Set();
      this._eventHandlers.set(eventName, handlers);
    }
    handlers.add({ fn: handler, once });
  }

  /**
   * Одноразовая подписка на событие
   * @param {string|symbol} eventName 
   * @param {() => void} handler 
   */
  once(eventName, handler) {
    this.on(eventName, handler, true);
  }

  /**
   * Удаляет обработчик события
   * @param {string|symbol} eventName 
   * @param {() => void} handler
   */
  off(eventName, handler) {
    const handlers = this._eventHandlers.get(eventName);
    if (!handlers) return;

    handlers.delete(handler);
  }
}

export const appEmitter = new Emitter();
